"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HighlightCardModule = _interopRequireDefault(require("./HighlightCard.module.css"));
var _PanelSection = _interopRequireDefault(require("../PanelSection/PanelSection"));
var HighlightCard = function HighlightCard(props) {
  var panelProps = props.panelProps,
    url = props.url,
    aligned = props.aligned,
    image = props.image,
    title = props.title,
    description = props.description,
    className = props.className;
  var handleRedirect = function handleRedirect() {
    if (!url) return;
    window.location.assign(url);
  };
  var cardClasses = "".concat(_HighlightCardModule["default"].HighlightCard, " ").concat(url ? _HighlightCardModule["default"].isLink : '', " ").concat(className);
  return /*#__PURE__*/_react["default"].createElement(_PanelSection["default"], Object.assign({}, panelProps, {
    className: cardClasses
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "highlight-card",
    style: {
      textAlign: aligned
    },
    className: _HighlightCardModule["default"].cardContent,
    onClick: handleRedirect
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _HighlightCardModule["default"].cardImage
  }, image), /*#__PURE__*/_react["default"].createElement("h4", {
    className: _HighlightCardModule["default"].cardTitle
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: _HighlightCardModule["default"].cardDescription
  }, description)));
};
HighlightCard.defaultProps = {
  image: undefined,
  aligned: 'center',
  title: undefined,
  description: undefined,
  url: undefined,
  className: '',
  panelProps: {
    backgroundColor: undefined,
    shadow: false,
    shadowColor: undefined
  }
};
var _default = HighlightCard;
exports["default"] = _default;